import React, {useMemo} from "react";
import {css, SerializedStyles, Theme} from "@emotion/react";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {calculateRemSize} from "@pg-design/helpers-css";

import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {useShouldShowPrice} from "../../../hooks/use_should_show_price";
import {useLeadFormSimplifiedAbTest} from "../../../lead/hooks/use_lead_form_simplified_ab_test";
import {GTMEventApplicationSourceSection} from "../../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";

interface IProps {
    vendorId: number;
    offerId: number;
    propertyId: number;
    propertyPrice?: number | null;
    propertyLink: string;
    applicationSource: number;
    applicationSourceSection: number;
    applicationButtonText?: string;
    moreInfoButtonText?: string;
    clickEvent?: () => void;
    hideApplicationButton?: boolean;
    className?: string;
    buttonSize?: IButtonSizePrimary;
    buttonStyle?: SerializedStyles;
}

export const QWActionButtons = (props: IProps) => {
    const {isFullOfferFormVariant} = useLeadFormSimplifiedAbTest();

    const {
        vendorId,
        offerId,
        propertyId,
        propertyPrice,
        propertyLink,
        applicationSource,
        applicationSourceSection,
        applicationButtonText,
        moreInfoButtonText,
        clickEvent,
        hideApplicationButton = false
    } = props;

    const target = useResponsiveLinkTarget();

    const handleDetailsButtonClick = () => clickEvent?.();

    const shouldShowPrice = useShouldShowPrice({
        vendorId: vendorId
    });

    const buttonText = useMemo(() => {
        if (applicationButtonText) {
            return applicationButtonText;
        }

        return getLeadButtonText({
            isPriceHidden: !shouldShowPrice,
            isProperty: !!propertyId,
            propertyPrice,
            isFullOfferFormVariant
        });
    }, [propertyPrice, propertyId, shouldShowPrice, applicationButtonText]);

    const gtmData: IGTMEventLeadForm = {
        clickText: buttonText,
        source: GTMEventApplicationSourceSection.SIDEBAR_MAP_DETAIL,
        vendorName: vendorId.toString(),
        offerName: offerId.toString()
    };

    return (
        <div css={buttonsHolder} className={props.className}>
            {!hideApplicationButton && (
                <ApplicationModalButton
                    source={applicationSource}
                    sourceSection={applicationSourceSection}
                    vendorId={vendorId}
                    offerId={offerId}
                    propertyId={propertyId}
                    render={({openModal}) => (
                        <Button variant="filled_primary" onClick={() => openModal(gtmData)} size={props.buttonSize || "big"} css={props.buttonStyle}>
                            {buttonText}
                        </Button>
                    )}
                />
            )}

            <Button
                as="a"
                href={propertyLink}
                onClick={handleDetailsButtonClick}
                target={target}
                variant="none_secondary"
                size={props.buttonSize}
                css={props.buttonStyle}
            >
                {moreInfoButtonText ?? "Zobacz szczegóły"}
            </Button>
        </div>
    );
};

const buttonsHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    padding-top: 3.6rem;
    gap: ${calculateRemSize(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        padding-top: 2.4rem;
        flex-direction: row;
        align-items: center;
    }
`;
import React, {useMemo} from "react";
import {css, SerializedStyles, Theme} from "@emotion/react";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {calculateRemSize} from "@pg-design/helpers-css";

import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {useShouldShowPrice} from "../../../hooks/use_should_show_price";
import {useLeadFormSimplifiedAbTest} from "../../../lead/hooks/use_lead_form_simplified_ab_test";
import {GTMEventApplicationSourceSection} from "../../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";

interface IProps {
    vendorId: number;
    offerId: number;
    propertyId: number;
    propertyPrice?: number | null;
    propertyLink: string;
    applicationSource: number;
    applicationSourceSection: number;
    applicationButtonText?: string;
    moreInfoButtonText?: string;
    clickEvent?: () => void;
    hideApplicationButton?: boolean;
    className?: string;
    buttonSize?: IButtonSizePrimary;
    buttonStyle?: SerializedStyles;
}

export const QWActionButtons = (props: IProps) => {
    const {isFullOfferFormVariant} = useLeadFormSimplifiedAbTest();

    const {
        vendorId,
        offerId,
        propertyId,
        propertyPrice,
        propertyLink,
        applicationSource,
        applicationSourceSection,
        applicationButtonText,
        moreInfoButtonText,
        clickEvent,
        hideApplicationButton = false
    } = props;

    const target = useResponsiveLinkTarget();

    const handleDetailsButtonClick = () => clickEvent?.();

    const shouldShowPrice = useShouldShowPrice({
        vendorId: vendorId
    });

    const buttonText = useMemo(() => {
        if (applicationButtonText) {
            return applicationButtonText;
        }

        return getLeadButtonText({
            isPriceHidden: !shouldShowPrice,
            isProperty: !!propertyId,
            propertyPrice,
            isFullOfferFormVariant
        });
    }, [propertyPrice, propertyId, shouldShowPrice, applicationButtonText]);

    const gtmData: IGTMEventLeadForm = {
        clickText: buttonText,
        source: GTMEventApplicationSourceSection.SIDEBAR_MAP_DETAIL,
        vendorName: vendorId.toString(),
        offerName: offerId.toString()
    };

    return (
        <div css={buttonsHolder} className={props.className}>
            {!hideApplicationButton && (
                <ApplicationModalButton
                    source={applicationSource}
                    sourceSection={applicationSourceSection}
                    vendorId={vendorId}
                    offerId={offerId}
                    propertyId={propertyId}
                    render={({openModal}) => (
                        <Button variant="filled_primary" onClick={() => openModal(gtmData)} size={props.buttonSize || "big"} css={props.buttonStyle}>
                            {buttonText}
                        </Button>
                    )}
                />
            )}

            <Button
                as="a"
                href={propertyLink}
                onClick={handleDetailsButtonClick}
                target={target}
                variant="none_secondary"
                size={props.buttonSize}
                css={props.buttonStyle}
            >
                {moreInfoButtonText ?? "Zobacz szczegóły"}
            </Button>
        </div>
    );
};

const buttonsHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    padding-top: 3.6rem;
    gap: ${calculateRemSize(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        padding-top: 2.4rem;
        flex-direction: row;
        align-items: center;
    }
`;
